import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { DialogType, ModalType, SimpleDialogParams } from '../../interfaces/simple-dialog';

import { Endpoint } from '../../constants/endpoints';
import BaseController from '../BaseController';
import { SimpleDialog } from '../dialog-helper';

export class EventListenerController {
  static delete: EventListener | undefined;
  static inactivate: EventListener | undefined;
  static addStandardText: EventListener | undefined;
}

class ClinicalNotesService {

  static isAllowEdit = false;

  ownerController: BaseController;

  constructor(ownerController: BaseController) {

    this.ownerController = ownerController;

  }

  async delete(patientId: number, encounterId: number, evolutionId: number): Promise<boolean> {
    const deleted: Promise<boolean> = HttpService.delete(

      Endpoint.DELETE_CLINICAL_NOTE,
      {
        encounterId,
        evolutionId,
        patientId,
      }

    ).then(response => {

      if (response.status === 200 && response.body === true) {
        applicationContext.popNavigationItem();

        return true;

      }

      return false;

    }).catch((err) => {

      throw err;

    });

    return deleted;
  }

  confirmDelete(patientId: number, encounterId: number, evolutionId: number): void {

    const dialogParams: SimpleDialogParams = {
      closeable: false,
      descriptionDialog: 'patient-evolution.delete-question-evolution',
      dialogType: DialogType.ACTION,
      modalType: ModalType.DIALOG,
      onClickCancel: () => { this.defaultDiscard() },
      onClickOk: async () => { await this.delete(patientId, encounterId, evolutionId) },
      titleDialog: 'patient-evolution.delete-question-evolution',
      titleOnCancel: 'patient-evolution.delete-notnow-evolution',
      titleOnOk: 'patient-evolution.delete-evolution',
    }

    SimpleDialog.openDialog(dialogParams);
  }

  release(patientId: string, encounterId: number, evolutionId: number): Promise<boolean> {

    const released: Promise<boolean> = HttpService.put(

      Endpoint.RELEASE_CLINICAL_NOTE,
      {
        encounterId,
        evolutionId,
        patientId,
      }

    ).then(response => {

      if (response.status === 200 && response.body === true) {
        applicationContext.popNavigationItem();

        return true;

      }

      return false;

    }).catch((err) => {

      throw err;

    });

    return released;
  }

  discardRelease(): void {

    this.ownerController.context.set({
      cdEvolucao: 0
    });

    applicationContext.popNavigationItem();
    applicationContext.popNavigationItem();

  }

  async inactivate(patientId: number, encounterId: number, evolutionId: number, dsJustification: string): Promise<boolean> {
    const inactivated: Promise<boolean> = HttpService.put(

      Endpoint.INACTIVATE_CLINICAL_NOTE,
      {
        dsJustification,
        encounterId,
        evolutionId,
        patientId,
      }

    ).then(response => {

      if (response.status === 200 && response.body === true) {
        applicationContext.popNavigationItem();
        applicationContext.popNavigationItem();
        return true;

      }

      return false;

    }).catch((err) => {

      throw err;

    });

    return inactivated;
  }

  confirmRelease(patientId: string, encounterId: number, evolutionId: number): void {

    const dialogParams: SimpleDialogParams = {
      closeable: false,
      dialogType: DialogType.ACTION,
      modalType: ModalType.DIALOG,
      onClickOk: async () => { await this.release(patientId, encounterId, evolutionId) },
      titleDialog: 'patient-evolution.release-title-evolution',
      titleOnOk: 'patient-evolution.release-submit-evolution',
    }

    SimpleDialog.openDialog(dialogParams);

  }

  confirmCancelAndRelease(patientId: string, encounterId: number, evolutionId: number): void {

    const dialogParams: SimpleDialogParams = {
      closeable: false,
      descriptionDialog: 'patient-evolution.release-title-evolution',
      dialogType: DialogType.ACTION,
      modalType: ModalType.DIALOG,
      onClickCancel: () => { this.discardRelease() },
      onClickOk: async () => { await this.release(patientId, encounterId, evolutionId) },
      titleDialog: 'patient-evolution.release-evolution',
      titleOnCancel: 'patient-evolution.release-cancel-evolution',
      titleOnOk: 'patient-evolution.release-submit-evolution',
    }

    SimpleDialog.openDialog(dialogParams);

  }

  confirmInactivate(): void {

    const dialogParams: SimpleDialogParams = {
      closeable: false,
      descriptionDialog: 'Deseja inativar nota clinica?',
      dialogType: DialogType.ACTION,
      fragment: 'patient-evolution-inactivation',
      modalType: ModalType.DIALOG,
      titleDialog: 'title.disable-record',
      titleOnCancel: 'patient-evolution.cancel',
      titleOnOk: 'patient-evolution.disable',
    }

    SimpleDialog.openDialog(dialogParams);
  }

  confirmStandardText(): void {

    const dialogParams: SimpleDialogParams = {
      closeable: true,
      descriptionDialog: 'form-title.clinical-notes-edit.standard-text',
      dialogType: DialogType.ACTION,
      fragment: 'clinical-notes-my-standard-text',
      modalType: ModalType.DIALOG,
      titleDialog: 'form-title.clinical-notes-edit.standard-text',
      titleOnCancel: 'tws.biometry.cancel',
      titleOnOk: 'tws-ok.ok-text',
    }

    SimpleDialog.openDialog(dialogParams);
  }

  defaultDiscard(): void {
    applicationContext.popNavigationItem();
  }

  showMessageDialog(title: string, description: string, onClickOk: () => void): void {

    const dialogParams: SimpleDialogParams = {
      closeable: false,
      descriptionDialog: description,
      dialogType: DialogType.ALERT,
      modalType: ModalType.DIALOG,
      onClickOk: onClickOk,
      titleDialog: title,
      titleOnOk: 'OK',
    }

    SimpleDialog.openDialog(dialogParams);
  }
}

export default ClinicalNotesService;
